import Link from 'next/link';
import styled from 'styled-components';

export default function BusinessSection() {
  return (
    <Container>
      <Wrapper>
        <TitleWrapper>
          <FakeTitle>비즈니스도 청연과 함께</FakeTitle>
          <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
          <TitleTablet>{TitleTabletSvg}</TitleTablet>
        </TitleWrapper>
        <Content>
          <Description>
            프로모션 제휴, 포인트 구매 등 다양한 B2B제휴부터 직원들의 삶의 질을 올려주는 청소복지까지 함께해요.
          </Description>
          <Buttons>
            <Link href="https://cleaninglab-official.notion.site/B2B-8a27c107a6024cddb684aeb4cde110a1" passHref>
              <Button target="_blank">
                B2B 제휴 문의 <ArrowRightIcon>{ArrowRightSvg}</ArrowRightIcon>
              </Button>
            </Link>
            <Link href="/b2b_introduction" passHref>
              <Button target="_blank">
                임직원 포인트 복지 <ArrowRightIcon>{ArrowRightSvg}</ArrowRightIcon>
              </Button>
            </Link>
          </Buttons>
        </Content>
      </Wrapper>
    </Container>
  );
}

const Container = styled.section`
  width: 100%;
  padding: 80px 24px 140px 24px;
  background: #42484c;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding: 58px 24px 60px 24px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 64px 24px 40px 24px;
  }
`;

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.mobile}; */
    flex-direction: column;
  }
`;

const TitleWrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 18px;
  }
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 486px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    width: 405px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: auto;
  }
`;

const Description = styled.h2`
  font-weight: 300;
  font-size: 21px;
  line-height: 140%;
  color: #ffffff;
  margin-bottom: 40px;
  max-width: 400px;
  word-break: keep-all;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
    width: 405px;
    max-width: 320px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 66px;
    width: auto;
    /* max-width: 330px; */
    max-width: none;
    font-weight: 400;
    word-break: break-all;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ArrowRightIcon = styled.span`
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;
`;

const Button = styled.a`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  border: 1px solid #ffffff;
  border-radius: 30px;
  padding: 13px 49px 13px 24px;
  color: #ffffff;
  margin-right: 24px;
  transition: 0.2s;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 15px;
    margin-right: 16px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 20px;
  }

  &:hover {
    color: rgba(0, 0, 0, 0.85);
    background: #ffffff;

    ${ArrowRightIcon} {
      right: 16px;

      svg path {
        stroke: rgba(0, 0, 0, 0.85);
      }
    }
  }
`;

const TitleDesktopSvg = (
  <svg width="216" height="105" viewBox="0 0 216 105" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.1979 27.8V2.73H18.0919V11.24H7.92589V2.73H2.86589V27.8H23.1979ZM18.0919 23.522H7.92589V15.564H18.0919V23.522ZM31.1559 39.07H36.2159V0.751998H31.1559V39.07ZM80.5103 34.47V30.192H41.7783V34.47H80.5103ZM58.1543 7.008C58.1083 8.664 57.7863 10.182 57.0963 11.516C54.9343 15.656 50.3803 18.278 45.0903 19.888L47.3903 23.89C53.6923 22.234 58.8903 18.692 61.1443 14.276C63.5363 18.554 68.6423 22.004 74.8983 23.614L77.1523 19.658C71.8623 18.186 67.2623 15.518 65.1003 11.424C64.4103 10.09 64.0883 8.618 64.0883 7.008H74.9903V2.73H47.2983V7.008H58.1543ZM109.533 21.452C104.151 22.556 97.2967 23.154 90.7187 23.016V3.006H85.6587V27.478C95.1807 27.662 103.691 27.11 110.131 25.776L109.533 21.452ZM113.903 39.07H118.963V0.751998H113.903V39.07ZM140.993 2.5V4.846C140.993 12.39 134.691 17.358 127.423 19.336L129.815 23.752C136.301 21.774 141.729 17.726 143.937 12.804C146.329 17.772 151.343 21.636 158.105 23.66L160.451 19.244C153.275 17.266 146.835 12.39 146.835 4.846V2.5H140.993ZM163.303 34.47V30.192H124.571V34.47H163.303ZM204.7 34.93V30.606H187.864V22.234H198.904V17.818H177.284V7.008H198.674V2.73H172.178V22.234H182.85V30.606H165.968V34.93H204.7ZM19.8859 65.214V60.844H6.72989V65.214H19.8859ZM30.9719 95.804C30.9719 98.748 28.3959 100.588 24.5779 100.588C20.8979 100.588 18.2759 98.748 18.2759 95.804C18.2759 92.86 20.8979 91.02 24.5779 91.02C28.3959 91.02 30.9719 92.86 30.9719 95.804ZM36.6759 86.144V60.614H31.5699V73.862H24.3019V78.14H31.5699V86.144H36.6759ZM10.5479 72.206C10.4559 73.31 10.2259 74.276 9.81189 75.15C8.24789 78.692 4.70589 80.808 0.749891 82.326L3.14189 86.374C7.69589 85.04 12.0199 81.36 13.4459 78.048C14.9179 81.314 19.5639 84.304 23.6119 85.546L25.8199 81.406C21.7259 80.302 18.3219 78.14 16.9419 74.874C16.6199 74.092 16.3899 73.172 16.2979 72.206H24.6239V67.882H1.94589V72.206H10.5479ZM36.1239 95.804C36.1239 90.514 31.3399 86.696 24.5779 86.696C17.9539 86.696 13.1239 90.514 13.1239 95.804C13.1239 101.186 17.9539 104.958 24.5779 104.958C31.3399 104.958 36.1239 101.186 36.1239 95.804ZM72.9203 66.502H62.1563C60.1323 64.386 57.1883 63.052 53.7383 63.052C47.2063 63.052 42.5143 67.698 42.5143 73.632C42.5143 79.704 47.2063 84.212 53.7383 84.212C57.4183 84.212 60.5463 82.786 62.5243 80.394H72.9203V90.284H78.0723V60.706H72.9203V66.502ZM78.6703 102.934V98.518H57.8783V87.8H52.7723V102.934H78.6703ZM59.9023 73.586C59.9023 77.082 57.2343 79.796 53.7383 79.796C50.1503 79.796 47.5743 77.082 47.5743 73.586C47.5743 70.09 50.1503 67.514 53.7383 67.514C57.2343 67.514 59.9023 70.09 59.9023 73.586ZM64.9623 73.632C64.9623 72.758 64.8243 71.838 64.6403 71.01H72.9203V75.978H64.7323C64.8703 75.242 64.9623 74.46 64.9623 73.632ZM106.405 63.098H84.6927V67.606H101.299C101.437 70.872 101.069 76.99 100.333 80.716L105.163 81.36C106.267 77.266 106.405 70.136 106.405 66.364V63.098ZM109.303 84.81C106.819 85.086 102.955 85.408 99.0447 85.684C97.7567 85.776 96.5147 85.822 95.3647 85.868V74.552H90.2587V86.052C89.6607 86.006 89.0167 86.006 88.3727 86.052C86.0267 86.052 83.7727 86.006 82.1167 86.006L82.6687 90.56H85.8887C89.3387 90.56 93.0187 90.468 96.1467 90.284C100.655 90.054 106.175 89.41 109.625 88.904L109.303 84.81ZM123.517 78.784V74.506H117.031V60.752H111.925V99.116H117.031V78.784H123.517ZM161.016 71.424V67.146H136.544V71.424H161.016ZM154.898 64.846V60.522H143.168V64.846H154.898ZM153.702 80.44C153.702 82.418 151.908 83.982 149.148 83.982C146.342 83.982 144.548 82.418 144.548 80.44C144.548 78.37 146.342 76.898 149.148 76.898C151.908 76.898 153.702 78.37 153.702 80.44ZM158.624 80.44C158.624 75.61 154.484 72.85 149.148 72.85C143.766 72.85 139.442 75.61 139.442 80.44C139.442 85.04 143.766 87.938 149.148 87.938C154.346 87.938 158.624 85.04 158.624 80.44ZM164.834 100.036H150.344V94.378H164.834V100.036ZM169.894 104.406V89.962H145.284V104.406H169.894ZM176.84 76.392V72.022H169.894V60.66H164.834V87.662H169.894V76.392H176.84ZM181.758 87.846C186.174 82.694 189.026 73.678 188.796 63.466H178.906V67.698H183.782C183.782 73.494 181.39 81.084 177.572 85.27L181.758 87.846ZM210.508 99.116H215.43V60.752H210.508V99.116ZM191.74 89.732C194.27 86.466 196.064 82.556 197.122 78.094L197.398 76.76H202.412V97.644H207.288V61.304H202.412V72.482H198.134C198.502 69.584 198.686 66.594 198.64 63.466H190.59V67.698H193.626C193.626 73.724 191.924 81.912 187.37 87.202L191.74 89.732Z"
      fill="white"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="130" height="65" viewBox="0 0 130 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0973 16.6V1.885H11.1003V6.88H5.13334V1.885H2.16334V16.6H14.0973ZM11.1003 14.089H5.13334V9.418H11.1003V14.089ZM18.7683 23.215H21.7383V0.723999H18.7683V23.215ZM48.2772 20.515V18.004H25.5432V20.515H48.2772ZM35.1552 4.396C35.1282 5.368 34.9392 6.259 34.5342 7.042C33.2652 9.472 30.5922 11.011 27.4872 11.956L28.8372 14.305C32.5362 13.333 35.5872 11.254 36.9102 8.662C38.3142 11.173 41.3112 13.198 44.9832 14.143L46.3062 11.821C43.2012 10.957 40.5012 9.391 39.2322 6.988C38.8272 6.205 38.6382 5.341 38.6382 4.396H45.0372V1.885H28.7832V4.396H35.1552ZM65.8521 12.874C62.6931 13.522 58.6701 13.873 54.8091 13.792V2.047H51.8391V16.411C57.4281 16.519 62.4231 16.195 66.2031 15.412L65.8521 12.874ZM68.4171 23.215H71.3871V0.723999H68.4171V23.215ZM84.858 1.75V3.127C84.858 7.555 81.159 10.471 76.893 11.632L78.297 14.224C82.104 13.063 85.29 10.687 86.586 7.798C87.99 10.714 90.933 12.982 94.902 14.17L96.279 11.578C92.067 10.417 88.287 7.555 88.287 3.127V1.75H84.858ZM97.953 20.515V18.004H75.219V20.515H97.953ZM122.791 20.785V18.247H112.909V13.333H119.389V10.741H106.699V4.396H119.254V1.885H103.702V13.333H109.966V18.247H100.057V20.785H122.791ZM12.1533 41.343V38.778H4.43134V41.343H12.1533ZM18.6603 59.298C18.6603 61.026 17.1483 62.106 14.9073 62.106C12.7473 62.106 11.2083 61.026 11.2083 59.298C11.2083 57.57 12.7473 56.49 14.9073 56.49C17.1483 56.49 18.6603 57.57 18.6603 59.298ZM22.0083 53.628V38.643H19.0113V46.419H14.7453V48.93H19.0113V53.628H22.0083ZM6.67234 45.447C6.61834 46.095 6.48334 46.662 6.24034 47.175C5.32234 49.254 3.24334 50.496 0.921344 51.387L2.32534 53.763C4.99834 52.98 7.53634 50.82 8.37334 48.876C9.23734 50.793 11.9643 52.548 14.3403 53.277L15.6363 50.847C13.2333 50.199 11.2353 48.93 10.4253 47.013C10.2363 46.554 10.1013 46.014 10.0473 45.447H14.9343V42.909H1.62334V45.447H6.67234ZM21.6843 59.298C21.6843 56.193 18.8763 53.952 14.9073 53.952C11.0193 53.952 8.18434 56.193 8.18434 59.298C8.18434 62.457 11.0193 64.671 14.9073 64.671C18.8763 64.671 21.6843 62.457 21.6843 59.298ZM43.8222 42.099H37.5042C36.3162 40.857 34.5882 40.074 32.5632 40.074C28.7292 40.074 25.9752 42.801 25.9752 46.284C25.9752 49.848 28.7292 52.494 32.5632 52.494C34.7232 52.494 36.5592 51.657 37.7202 50.253H43.8222V56.058H46.8462V38.697H43.8222V42.099ZM47.1972 63.483V60.891H34.9932V54.6H31.9962V63.483H47.1972ZM36.1812 46.257C36.1812 48.309 34.6152 49.902 32.5632 49.902C30.4572 49.902 28.9452 48.309 28.9452 46.257C28.9452 44.205 30.4572 42.693 32.5632 42.693C34.6152 42.693 36.1812 44.205 36.1812 46.257ZM39.1512 46.284C39.1512 45.771 39.0702 45.231 38.9622 44.745H43.8222V47.661H39.0162C39.0972 47.229 39.1512 46.77 39.1512 46.284ZM64.0161 40.101H51.2721V42.747H61.0191C61.1001 44.664 60.8841 48.255 60.4521 50.442L63.2871 50.82C63.9351 48.417 64.0161 44.232 64.0161 42.018V40.101ZM65.7171 52.845C64.2591 53.007 61.9911 53.196 59.6961 53.358C58.9401 53.412 58.2111 53.439 57.5361 53.466V46.824H54.5391V53.574C54.1881 53.547 53.8101 53.547 53.4321 53.574C52.0551 53.574 50.7321 53.547 49.7601 53.547L50.0841 56.22H51.9741C53.9991 56.22 56.1591 56.166 57.9951 56.058C60.6411 55.923 63.8811 55.545 65.9061 55.248L65.7171 52.845ZM74.0601 49.308V46.797H70.2531V38.724H67.2561V61.242H70.2531V49.308H74.0601ZM97.1504 44.988V42.477H82.7864V44.988H97.1504ZM93.5594 41.127V38.589H86.6744V41.127H93.5594ZM92.8574 50.28C92.8574 51.441 91.8044 52.359 90.1844 52.359C88.5374 52.359 87.4844 51.441 87.4844 50.28C87.4844 49.065 88.5374 48.201 90.1844 48.201C91.8044 48.201 92.8574 49.065 92.8574 50.28ZM95.7464 50.28C95.7464 47.445 93.3164 45.825 90.1844 45.825C87.0254 45.825 84.4874 47.445 84.4874 50.28C84.4874 52.98 87.0254 54.681 90.1844 54.681C93.2354 54.681 95.7464 52.98 95.7464 50.28ZM99.3914 61.782H90.8864V58.461H99.3914V61.782ZM102.361 64.347V55.869H87.9164V64.347H102.361ZM106.438 47.904V45.339H102.361V38.67H99.3914V54.519H102.361V47.904H106.438ZM109.865 54.627C112.457 51.603 114.131 46.311 113.996 40.317H108.191V42.801H111.053C111.053 46.203 109.649 50.658 107.408 53.115L109.865 54.627ZM126.74 61.242H129.629V38.724H126.74V61.242ZM115.724 55.734C117.209 53.817 118.262 51.522 118.883 48.903L119.045 48.12H121.988V60.378H124.85V39.048H121.988V45.609H119.477C119.693 43.908 119.801 42.153 119.774 40.317H115.049V42.801H116.831C116.831 46.338 115.832 51.144 113.159 54.249L115.724 55.734Z"
      fill="white"
    />
  </svg>
);

const ArrowRightSvg = (
  <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.444 3L20.3999 7.97787L15.3999 13"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M20.3999 8.03516H1.3999" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
